import React from 'react';
import { StanButton } from '@/components';
import { CancellationModalWrapper } from './CancellationModalWrapper';
import { OFFER_ACCEPTED_MODAL_STRINGS } from '../../constants/cancellationStrings';
import FreeMonthActivatedImage from '@/assets/images/cancelation/freeMonthActivated.png';

interface OfferAcceptedModalProps {
    isOpen: boolean;
    offerType: 'free-month' | 'two-months-discount';
    onClose: () => void;
}

export const OfferAcceptedModal = ({ isOpen, offerType, onClose }: OfferAcceptedModalProps) => {
    const isFreeMonth = offerType === 'free-month';
    const strings = isFreeMonth
        ? OFFER_ACCEPTED_MODAL_STRINGS.FREE_MONTH
        : OFFER_ACCEPTED_MODAL_STRINGS.TWO_MONTHS_DISCOUNT;

    return (
        <CancellationModalWrapper isOpen={isOpen}>
            <div className='flex flex-col items-center space-y-6 pt-6 text-center'>
                {/* Image */}
                {isFreeMonth && (
                    <div className='w-full max-w-md'>
                        <img
                            src={FreeMonthActivatedImage}
                            alt={OFFER_ACCEPTED_MODAL_STRINGS.FREE_MONTH.IMAGE_ALT}
                            className='w-full'
                        />
                    </div>
                )}

                {/* Title */}
                <h2 className='text-heading-heading2 leading-tight'>{strings.TITLE}</h2>

                {/* Description */}
                <div className='text-body-1-regular text-text-secondary max-w-md'>
                    <span className='font-bold'>{strings.SUBTITLE}</span> {strings.DESCRIPTION}
                </div>

                {/* Button */}
                <div className='w-full max-w-md pt-4'>
                    <StanButton name='go-back-offer-accepted' size='lg' onClick={onClose} className='w-full'>
                        {OFFER_ACCEPTED_MODAL_STRINGS.BUTTON_LABEL}
                    </StanButton>
                </div>
            </div>
        </CancellationModalWrapper>
    );
};
